import type { FormKind } from '@tunasong/music-lib'

export type FormSubMode = 'explore' | 'quiz'

/** Parse `?mode=…` URL param into a FormSubMode, or null when invalid/absent. */
export const parseFormSubMode = (raw: string | null): FormSubMode | null => {
  if (raw === 'explore' || raw === 'quiz') {
    return raw
  }
  return null
}

/** Parse `?form=…` URL param into a FormKind, or null when invalid/absent. */
export const parseFormKindParam = (raw: string | null): FormKind | null => {
  if (
    raw === '12-bar-blues' ||
    raw === '32-bar-aaba' ||
    raw === 'verse-chorus' ||
    raw === 'strophic'
  ) {
    return raw
  }
  return null
}
